import { format } from 'utils/time/format';
import { isoDatePatternWithSlashes } from 'utils/time/datePatterns';
import { CahierJournalView } from 'containers/CahierJournal/types';

export const cjRoutes = {
  root: ({
    schoolyearId,
    schoolId,
    view,
    date,
  }: {
    schoolyearId: string;
    schoolId: string;
    view: CahierJournalView;
    date: Date;
  }) =>
    `/annee-scolaire/${schoolyearId}/ecole/${schoolId}/cahier-journal/${view}/${format(
      date,
      'fr-FR',
      isoDatePatternWithSlashes,
    )}`,

  preview: ({
    schoolyearId,
    schoolId,
    view,
    date,
  }: {
    schoolyearId: string;
    schoolId: string;
    view: CahierJournalView;
    date: Date;
  }) =>
    `${cjRoutes.root({
      schoolyearId,
      schoolId,
      view,
      date,
    })}/preview`,
  shareRoot: ({
    userId,
    token,
    view,
    date,
  }: {
    userId: string;
    token: string;
    view: CahierJournalView;
    date: Date;
  }) =>
    `/shares/${userId}/t/${token}/cahier-journal/${view}/${format(
      date,
      'fr-FR',
      isoDatePatternWithSlashes,
    )}`,

  previewShare: ({
    userId,
    token,
    view,
    date,
  }: {
    userId: string;
    token: string;
    view: CahierJournalView;
    date: Date;
  }) =>
    `${cjRoutes.shareRoot({
      userId,
      token,
      view,
      date,
    })}/preview`,
};
